Greenmile.Checks = Greenmile.Checks || {};
Greenmile.Checks.EventCheck = Greenmile.Checks.EventCheck || {};

Greenmile.Checks.EventCheck.MinimumRestTime = {
  template: () => {
    return {
      tag: "div",
      items: [
        {
          items: [
            {
              tag: "label",
              items: [
                {
                  tag: "span",
                  html: Monet.I18n.getResourcesByKey(
                    "event.check.minimumRestTime.timeMinutes",
                  ),
                  attributes: {
                    class: "i18nResource",
                  },
                },
              ],
              attributes: {
                class: "control-label",
                for: "minimum_rest_time_minutes",
              },
            },
            {
              items: [
                {
                  tag: "input",
                  attributes: {
                    type: "text",
                    name: "minimum_rest_time_minutes",
                    maxlength: "10",
                    alt: "",
                    value: "",
                    size: "11",
                    id: "minimum_rest_time_minutes",
                    class: "modelAttribute textField numberPicker mandatory",
                    autocomplete: "off",
                  },
                },
              ],
              attributes: {
                class: "controls",
              },
            },
          ],
          attributes: {
            class: "control-group",
          },
        },
      ],
    };
  },

  assignParameter: jsonParam => {
    if (jsonParam) {
      const timeMinutes = document.getElementById("minimum_rest_time_minutes");
      jsonParam = JSON.parse(jsonParam);
      timeMinutes.value = jsonParam.timeMinutes;
    }
  },

  retrieveParameter: () => {
    const timeMinutes = document.getElementById("minimum_rest_time_minutes")
      .value;

    return JSON.stringify({
      timeMinutes: timeMinutes,
    });
  },
};